import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getStatusCardAnimatedTextStyles = () => {
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignSelf: 'center',
      marginTop: tokens.spacing.SPACING_20
    },
    animatedNumber: {
      marginRight: tokens.spacing.SPACING_4
    },
    title: {
      textAlign: 'center'
    }
  });
};